import {memo} from 'react'
import * as React from 'react'
import type {XYCoord} from 'react-dnd'
import {useDragLayer} from 'react-dnd'

import type {ProjectOrBuildTypeNode} from '../../../../types'
import type {QueueBuildDragItem} from '../QueueBuild/QueueBuild'
import {BuildDragType} from '../QueueBuild/QueueBuild'

import QueueBuildDragLayer from './QueueBuildDragLayer'

import styles from './QueueBuildDragLayer.css'

type Props = {
  wrapped?: boolean
  pathFilter?: ProjectOrBuildTypeNode | null
}

const getItemStyles = (initialOffset: XYCoord | null, currentOffset: XYCoord | null) => {
  if (!initialOffset || !currentOffset) {
    return {
      display: 'none',
    }
  }

  const {x, y} = currentOffset

  const transform = `translate(${x}px, ${y}px)`
  return {
    transform,
    WebkitTransform: transform,
  }
}

function QueueBuildDragLayerContainer(props: Props) {
  const {wrapped = false, pathFilter} = props

  const {itemType, isDragging, item, initialOffset, currentOffset} = useDragLayer(monitor => ({
    item: monitor.getItem<QueueBuildDragItem>(),
    itemType: monitor.getItemType(),
    initialOffset: monitor.getInitialSourceClientOffset(),
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging(),
  }))

  return itemType === BuildDragType && isDragging ? (
    <div className={styles.layer}>
      <div
        style={{
          ...getItemStyles(initialOffset, currentOffset),
          height: item.height,
          width: item.width,
        }}
      >
        <QueueBuildDragLayer buildId={item.buildId} wrapped={wrapped} pathFilter={pathFilter} />
      </div>
    </div>
  ) : null
}

export default memo(QueueBuildDragLayerContainer)
